import { render } from "./ActiveOrderBottomWidget.vue?vue&type=template&id=0fc78b43"
import script from "./ActiveOrderBottomWidget.vue?vue&type=script&lang=js"
export * from "./ActiveOrderBottomWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__